import { render, staticRenderFns } from "./NewsPress.html?vue&type=template&id=5a9e1002&scoped=true&"
import script from "./NewsPress.ts?vue&type=script&lang=ts&"
export * from "./NewsPress.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/press/_press.scss?vue&type=style&index=0&id=5a9e1002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e1002",
  null
  
)

export default component.exports